import { create } from 'zustand';
import type { ReactNode } from 'react';

type BreadcrumbItem = {
  label: string;
  href?: string;
};

type HeaderButton = {
  label: string;
  iconName?: string;
  iconFill?: 1 | 0;
  requiredScopes?: string[];
  allowMaster?: boolean;
  style?: 'default' | 'outline';
  onClick: () => void;
  modal?: (args: { open: boolean; setOpen: (open: boolean) => void }) => ReactNode;
};

type HeaderState = {
  title: string;
  breadcrumb: BreadcrumbItem[];
  button?: HeaderButton[];
  backButton?: boolean;
  setHeader: (data: {
    title: string;
    breadcrumb: BreadcrumbItem[];
    button?: HeaderButton[];
    backButton?: boolean;
  }) => void;
  gradient?: boolean;
  setGradient: (value: boolean) => void;
};

export const useHeaderStore = create<HeaderState>((set) => ({
  title: '',
  breadcrumb: [],
  button: undefined,
  backButton: false,
  gradient: false,
  setGradient: (value) => set(() => ({ gradient: value })),
  setHeader: ({ title, breadcrumb, backButton = false, button }) =>
    set(() => ({
      title,
      breadcrumb,
      backButton,
      button,
    })),
}));
